<template>
    <div class="section-getfriend">
        <div class="wrapper-profile-img">
            <img class="profile-img" :src="lineImage" />
            <img class="profile-logo" src="@/assets/logo/navbar_logo_naos@2x.svg" />
        </div>
        <div class="wrapper-point">
            <div class="box-point">
                <div class="text-get">{{lbl.text_get}}</div>
                <div class="mission-point">
                    <div class="text">
                    <span class="use-point">{{missionPoint | number_format}}</span>
                        <span>
                            <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-descrition">{{lbl.text_invite}}</div>
        <div class="text-campaign">{{lbl.text_max_invite}}</div>
        <div class="text-collect">{{textCollect}}</div>
        <div class="box-icon-star">
            <div class="icon-star" v-for="(v,k) in allItem" :key="k">
                <img class="img-fluid" src="@/assets/icon/mission_icon_inactive.svg"
                    v-if="(k+1) > productCollect"/>
                <img class="img-fluid" src="@/assets/icon/mission_icon_active.svg" 
                    v-if="(k+1) <= productCollect"/>
            </div>
        </div>
        <!-- <div class="img-people">
            <img src="@/assets/other/img-getfriend.svg" />
        </div> -->
        <div class="btn-get-friend" @click="clickInvite()">
            <div class="btn-txt">
                <img class="icon-line" src="@/assets/icon/icon-line.svg" />
                {{lbl.btn_line}}
            </div>
        </div>
        
    </div>
</template>
<script>
// helper
import Util from '@/helper/Utility.js';
import LineFunction from "@/helper/facade/LineFunction.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//service
import GetFriendApi from "@/core/GetFriend/service/GetFriendApi.js";

export default {
    name: 'GetFriend',
    mixins: [AccountMixin, ErrorApiMixin],
    props:{
        lbl: Object,
        modalController: Object,
        isLoading: Boolean,
        badgeDetail: Object,
        lineImage: String,
    },
    data: function () {
        return {
            textCollect: '',
            missionPoint: '',

            allItem: 0,
            productCollect: null,
        };
    },
    created: function(){
        this.initialMission();
    },
    methods:{
        initialMission: function(){
            this.showLoading();

            if(!this.badgeDetail) return;
            this.hideLoading();

            var mission = this.badgeDetail;
            console.log('mission', mission)

            if(mission.CustomInfo){
                this.missionPoint = JSON.parse(mission.CustomInfo).point;
            }
            
            this.allItem = mission.Missions[0].Value;
            this.productCollect = mission.Missions[0].Current;

            this.textCollect = `ชวนเพื่อนไปแล้ว ${this.productCollect}/${this.allItem}`;
        },
        clickInvite: async function () {
            var linkShare = await this.getLinkFriendGetFriend();
            if (Util.isEmptyStr(linkShare)) return;
           
            var lineFunction = new LineFunction();
            var liffId = lineFunction.getLiffId();
            lineFunction.init(liffId).then(() => {
                lineFunction.shareTextToFriends(linkShare).then((data) => {
                    // success
                    console.log(data);
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        //method
        getLinkFriendGetFriend: async function () {
            return new Promise((resolve) => {
                var token = this.getToken();
                GetFriendApi.getFriendLink(token).subscribe((res) => {
                    console.log(res.link);
                    resolve(res.link);
                }, (err) => {
                    this.errorApi(err);
                    resolve(null);
                });
            });
        },
        //utilities
        showLoading: function () {
            if (this.isLoading) return true;
            this.toggleLoading(true);

            return false;
        },
        hideLoading: function () {
            this.toggleLoading(false);
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
@import '@/style/input/BaseButton.scss';

.section-getfriend{
    text-align: center;
    padding-bottom: 20px;

    .wrapper-profile-img{
        width: 123px;
        margin: auto;
        
        .profile-img{
            width: 123px;
            border: 5px solid $white;
            border-radius: 50%;
            box-shadow: $box-shadow;
            margin-top: -50px;
        }
        .profile-logo{
            width: 93px;
            margin-top: -30px;
        }
    }

    .wrapper-point{
        padding-top: 8px;
        width: fit-content;
        margin: auto;

        .box-point{
            @extend %display-flex;
            width: fit-content;
            align-items: center;

            .text-get{
                font-family: $medium;
                font-size: 1.12rem;
                color: $blue-dark-gray;
                padding-right: 7px;
            }
            .mission-point{
                flex: 0 0 80px;
                width: 80px;
                height: 33px;
                position: relative;
                font-size: 1.8rem;
                padding: 1px 2px 1px 12px;
                border-radius: 30px;
                background-color: $blue-gray;
                margin: auto;
                .text {
                    @extend %display-flex;
                    width: 100%;

                    .use-point {
                        flex: 0 0 59%;
                        width: 59%;
                        margin-top: 8px;
                        font-family: $medium;
                        font-size: 1.12rem;
                        line-height: 1;
                        text-align: left;
                        color: $white;

                        @include mini-mobile() {
                            font-size: 1rem;
                        }
                    }
                    .icon-point {
                        flex: 0 0 35%;
                        width: 25px;
                        margin-top: -15px;

                        @include mini-mobile() {
                            flex: 0 0 43%;
                            width: 20px;
                        }
                    }
                }
            }
        }
    }

    .text-descrition{
        color: $bright-gray;
        padding-top: 25px;
    }

    .text-campaign{
        color: $bright-gray;
        font-family: $medium;
        font-size: 1.12rem;
        padding: {
            top: 5px;
            bottom: 20px;
        }
    }

    .text-collect{
        color: $pink;
        font-family: $medium;
        font-size: 1.12rem;
    }

    .box-icon-star{
        @extend %display-flex;
        width: 85%;
        margin: auto;
        padding: 15px 0 30px;

        .icon-star{
            flex: 0 0 calc(100% / 4);
            width: calc(100% / 4);
        }
    }

    .btn-get-friend{
        @include btn-wrapper($bg-color: $green-dark);
        position: relative;
        width: 90%;
        margin: 20px auto;

        .icon-line{
            padding-right: 5px;
        }
    }
}
</style>